import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useBaseCompanyStore = defineStore('baseCompany', () => {
  const name = ref<string>('');
  const companyId = ref();
  const imprint = ref<string>('');

  return { name, companyId, imprint };
});
